import { render } from "./accountRecords.vue?vue&type=template&id=f4eb036a&scoped=true"
import script from "./accountRecords.vue?vue&type=script&lang=js"
export * from "./accountRecords.vue?vue&type=script&lang=js"

import "./accountRecords.vue?vue&type=style&index=0&id=f4eb036a&scoped=true&lang=css"

import exportComponent from "D:\\learning\\isp_digital\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4eb036a"]])

export default __exports__